module.exports = __webpack_public_path__ + "img/button_share.138200a8.png";